import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, MessagesSquare } from "lucide-react";

export function BuiltTogetherTeaser() {
  return (
    <section
      className="py-24 md:py-28 border-y border-white/5 bg-white/[0.015]"
      data-testid="built-together-teaser"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="section-mark" />
            <span className="overline">Built Together</span>
            <span className="section-mark" />
          </div>

          <h2 className="h-display text-white text-4xl md:text-5xl leading-[1.05] mb-6">
            Help build the <span className="text-[#F47A20]">next ROADRIG</span>.
          </h2>

          <p className="text-white/70 text-base md:text-lg leading-relaxed max-w-2xl mx-auto mb-4">
            {"ROADRIG isn't just being built by us. It's being built by riders. If there's something you've always wanted in a motorcycle bag — or something that drives you crazy about the ones you've owned — tell us. Your idea could end up in the next version."}
          </p>
          <p className="text-white/50 text-sm max-w-xl mx-auto mb-10">
            {"We can't promise we'll use every idea. But we can promise we'll read every single one."}
          </p>

          <Link
            to="/feedback"
            data-testid="feedback-teaser-cta"
            className="btn-primary inline-flex items-center gap-2"
          >
            <MessagesSquare size={16} />
            Share your idea
            <ArrowRight size={16} />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
